import { mergeStyleSets, getTheme } from "@fluentui/react";

const theme = getTheme();

export const styles = mergeStyleSets({
  // Table container and state styles

  rolloutDetailsTableLoading: {
    padding: "20px",
    textAlign: "center" as const,
  },

  rolloutDetailsTableError: {
    marginTop: "24px",
    padding: "20px",
    backgroundColor: theme.palette.neutralLighterAlt,
    borderRadius: "8px",
    color: theme.palette.redDark,
    border: `1px solid ${theme.palette.redDark}`,
  },

  rolloutDetailsTableEmpty: {
    marginTop: "24px",
    padding: "20px",
    backgroundColor: theme.palette.neutralLighter,
    borderRadius: "8px",
    color: theme.palette.neutralSecondary,
    textAlign: "center" as const,
  },

  rolloutDetailsReview: {
    padding: "24px",
    textAlign: "center" as const,
    color: theme.palette.neutralSecondary,
    fontSize: "16px",
  },
  rolloutDetailsTable: {
    background: theme.palette.white,
    width: "100%",
    minWidth: "0",
  },
  // Column-specific styles
  rolloutDetailsColumnRunIdLink: {
    color: theme.palette.themePrimary,
    textDecoration: "none",
    fontWeight: "500",
  },

  rolloutDetailsColumnEnvironment: {
    fontWeight: "500",
    color: theme.palette.neutralSecondary,
  },

  rolloutDetailsColumnCreationDate: {
    color: theme.palette.neutralSecondary,
  },

  rolloutDetailsColumnApproval: {
    color: theme.palette.themePrimary,
    textDecoration: "none",
    fontSize: "14px",
    padding: "4px 8px",
    border: `1px solid ${theme.palette.themePrimary}`,
    borderRadius: "4px",
    background: theme.palette.themeLight,
    display: "inline-block",
  },

  rolloutDetailsColumnEv2: {
    color: theme.palette.orange,
    textDecoration: "none",
    fontSize: "14px",
    padding: "4px 8px",
    border: `1px solid ${theme.palette.orange}`,
    borderRadius: "4px",
    background: `${theme.palette.orange}1A`,
    display: "inline-block",
  },

  rolloutDetailsColumnEv2Status: {
    display: "inline-block",
    width: "auto",
    textAlign: "center",
  },

  rolloutDetailsColumnExpStudio: {
    color: theme.palette.themePrimary,
    textDecoration: "none",
    fontSize: "14px",
    padding: "4px 8px",
    border: `1px solid ${theme.palette.themePrimary}`,
    borderRadius: "4px",
    background: theme.palette.themeLight,
    display: "inline-block",
  },

  rolloutDetailsColumnExpStudioWarning: {
    color: theme.palette.orange,
  },
});
